import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import { MiContentDrawer, MiDetailFields } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  INPUT_TYPES,
} from "@miplatform/constants";
import {
  getUpdatedFields,
  updateFieldsetFromSchemaRequirements,
} from "@miplatform/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { mdiAccount } from "@mdi/js";
import { schema } from "../userSchema";

export function AddUserDrawer({
  onClose,
  onSubmit,
  header,
  loading,
  data,
  roles,
  type,

  ...rest
}) {
  const { classes } = useStyles();
  const {
    control,
    reset,
    handleSubmit,
    getValues,
    formState: { dirtyFields, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      firstName: "",
      lastName: "",
      userName: "",
      displayName: "",
      email: "",
      roleIds: [],
      title: "",
    },
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (data) {
      reset(data);
    } else {
      reset();
    }
  }, [data]);

  const userFields = [
    {
      label: "First Name",
      name: "firstName",
      formControl: control,
      width: "100%",
    },
    {
      label: "Last Name",
      name: "lastName",
      formControl: control,
      width: "100%",
    },
    {
      label: "User Name",
      name: "userName",
      formControl: control,
      width: "100%",
    },
    {
      label: "Display Name",
      name: "displayName",
      formControl: control,
      width: "100%",
    },
    {
      label: "Email",
      name: "email",
      formControl: control,
      width: "100%",
    },
    {
      label: "Roles",
      fieldType: INPUT_TYPES.MULTI_SELECT,
      name: "roleIds",
      options: roles,
      formControl: control,
    },
    {
      label: "Title",
      name: "title",
      formControl: control,
      width: "100%",
    },
  ];

  const handleDrawerClose = () => {
    onClose();
    reset();
  };

  const handleSubmitHandler = (data) => {
    if (type === "edit") {
      onSubmit({ id: data?.id, ...getUpdatedFields(dirtyFields, getValues()) });
    } else {
      onSubmit(getValues());
    }
  };

  return (
    <MiContentDrawer
      variant="temporary"
      onClose={handleDrawerClose}
      leftIcon={mdiAccount}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          onClick: handleDrawerClose,
          color: BUTTON_COLORS.BLACK,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          color: BUTTON_COLORS.PRIMARY,
          size: "medium",
          disabled: !isValid || loading,
          onClick: handleSubmit(handleSubmitHandler),
        },
      ]}
      isLoading={loading}
      title={header}
      topRightClose={reset}
      {...rest}
    >
      <MiDetailFields
        detailFields={updateFieldsetFromSchemaRequirements(schema, userFields)}
        customWrapperStyle={classes.container}
      />
    </MiContentDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));
